import { computed } from "vue";

export type ISelectionControlModelValue =
  | boolean
  | string
  | number
  | null
  | (boolean | string | number)[];

export interface ISelectionControlEmit {
  (
    event: "update:modelValue",
    value: Partial<ISelectionControlModelValue>,
    e: Event
  ): void;
  [key: string]: never;
}

export default function (
  props: {
    modelValue: ISelectionControlModelValue;
    value: boolean | string | number;
    [key: string]: any;
  },
  emit: ISelectionControlEmit
) {
  const isChecked = computed(() =>
    Array.isArray(props.modelValue)
      ? props.modelValue.includes(props.value)
      : props.modelValue === props.value
  );

  function getNextValue() {
    if (Array.isArray(props.modelValue)) {
      if (isChecked.value) {
        const val = props.modelValue.slice();
        val.splice(props.modelValue.indexOf(props.value), 1);
        return val;
      }

      return props.modelValue.concat([props.value]);
    }

    if (isChecked.value) {
      switch (typeof props.value) {
        case "string":
          return "";
        case "number":
          return null;
        default:
          return false;
      }
    } else {
      return props.value;
    }
  }

  function onChange(e: Event) {
    emit("update:modelValue", getNextValue(), e);
  }

  return {
    isChecked,
    onChange,
  };
}
